var $doc = $(document);
var $win = $(window);
var cachedScrollPos;
var currentScrollPos = $doc.scrollTop();
var layoutType = null;

function layoutTypeChange() {
  if ($win.width() < 768) {
    if ( layoutType === 'mobile' ) {
      return;
    }

    layoutType = 'mobile';
    handleTabLayout($('.tabs-navigation'));
  } else if ($win.width() > 767 && $win.width() < 1024) {
    if ( layoutType === 'tablet' ) {
      return;
    }

    layoutType = 'tablet';
    handleTabLayout($('.tabs-navigation'));
  } else {
    if ( layoutType === 'desktop' ) {
      return;
    }
    layoutType = 'desktop';
    handleTabLayout($('.tabs-navigation'));
  }
}

$win.on('load', layoutTypeChange);
$win.on('resize', layoutTypeChange);

function handleTabLayout($tabParent) {
  var $firstNavItem = $tabParent.find('.tabs__nav');
  var $firstTabItem = $tabParent.find('.tabs__body');

  if ( $win.width() < 1024 ) {
    //$firstNavItem.add($firstTabItem).removeClass('current');
    $firstNavItem.each(function () {
      $(this).find('li').eq(0).removeClass('current');
    });

    $firstTabItem.each(function () {
      $(this).find('.tab').eq(0).removeClass('current');
    });
  } else {
    //$firstNavItem.add($firstTabItem).addClass('current');
    $firstNavItem.each(function () {
      $(this).find('li').eq(0).addClass('current');
    });

    $firstTabItem.each(function () {
      $(this).find('.tab').eq(0).addClass('current');
    });
  }
}

function initMaps() {
  $('.googlemap').each(function () {
    var centerLat = parseFloat($(this).data('lat'));
    var centerLng = parseFloat($(this).data('lng'));
    var zoom = parseFloat($(this).data('zoom'));

    if ( zoom === 0 ) {
      zoom = 14;
    }

    var myLatLng = { lat: centerLat, lng: centerLng };

    var mapOptions = {
      center: myLatLng,
      zoom: zoom,
      mapTypeId: google.maps.MapTypeId.roadmap,
      scrollwheel: false
    };

    var map = new google.maps.Map(this, mapOptions);
    // this log is only to prevent errors in terminal
    console.log(map);
  });
}

window.initMaps = initMaps;

function initSlider($slider, sliderOptions) {
  $slider.slick(sliderOptions);
}

function setVideoSizes($video, $videoParent) {
  //Full screen video
  var ratio = 16 / 9;
  var playerHeight;
  var playerWidth;
  var $playerHolder = $videoParent;

  $win.on('load resize', function () {
    var width = $playerHolder.width('').width();
    var height = $playerHolder.height('').height();

    if ( width / ratio < height ) { // if new video height < window height (gap underneath)
      playerWidth = Math.ceil(height * ratio); // get new player width
      $video.width(playerWidth).height(height).css({left: (width - playerWidth) / 2, top: 0}); // player width is greater, offset left; reset top
    } else { // new video width < window width (gap to right)
      playerHeight = Math.ceil(width / ratio); // get new player height
      $video.width(width).height(playerHeight).css({left: 0, top: (height - playerHeight) / 2}); // player height is greater, offset top; reset left
    }
  });
}

function loadGraphData(src) {
  return $.ajax({
    url: src,
    dataType: 'json',
    error: function (jqXHR, textStatus, errorThrown) {
      console.error(errorThrown);
    }
  });
}

var labelSize = 16;

if ( $win.width() < 768 ) {
  labelSize = 9;
}

function initBarChart(ctx, data) {
  return new Chart(ctx, {
    type: 'bar',
    data: data,
    options:{
      responsive: true,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            display:false
          },
          ticks: {
            fontSize: labelSize
          },
          categoryPercentage: 1.0
        }],
        yAxes: [{
          gridLines: {
            drawBorder: false
          },
          ticks: {
            fontSize: labelSize,
            min: 0,
            max: 4000,
            stepSize: 1000
          }
        }]
      }
    }
  });
}

function initMixedBarLineChart(ctx, data) {
  return new Chart(ctx, {
    type: 'bar',
    data: data,
    options: {
      responsive: true,
      title: {
        display: false
      },
      legend: {
        display: false
      },
      elements: {
        point: {
          pointStyle: 'circle'
        }
      },
      scales: {
        xAxes: [{
          gridLines: {
            display:false
          },
          ticks: {
            fontSize: labelSize
          },
          categoryPercentage: 1.0
        }],
        yAxes: [{
          gridLines: {
            drawBorder: false
          },
          ticks: {
            fontSize: labelSize,
            min: 0,
            stepSize: 5000
          }
        }]
      }
    }
  });
}

function triggerTabFromSelect(value, $parent) {
  if ( value === '') {
    $parent.find('.current').removeClass('current');
  } else {
    $(value).addClass('current').siblings().removeClass('current');
    $('.tabs__nav a[href=" + value +"]').parent().addClass('current').siblings().removeClass('current');
  }
}

$doc.ready(function () {
  $win.on('scroll', function () {
    currentScrollPos = $doc.scrollTop();
  });

  $doc.foundation();

  var $searchOverlay = $('.search-overlay');
  var $searchMenu = $searchOverlay.find('.search-main');
  var $searchResults = $searchOverlay.find('.search-results');
  var $searchClose = $searchOverlay.find('.btn-close');
  var $searchInput = $searchMenu.find('.search-dropdown-expander');

  $('.search-expand').on('click', function (event) {
    event.preventDefault();
    $searchOverlay.addClass('show');
    $searchInput.focus();
  });

  $searchClose.on('click', function (event) {
    event.preventDefault();

    $searchOverlay.removeClass('show');
    $('.search-dropdown-expander').val('');
    $searchResults.removeClass('show').css({ height : 0 });
    $('body').removeClass('lockscroll').css({ top: 0 }).scrollLock('disable');
    $('html, body').scrollTop(cachedScrollPos);
  });

  $searchInput.on('input', function () {
    var $this = $(this);

    if ( $this.val().length >= 3 ) {
      $searchResults.addClass('show').scrollLock('enable');
      $searchResults.css({'height': $win.height() - $searchMenu.outerHeight()});
      cachedScrollPos = currentScrollPos;
      var scrollTop = -Math.abs(currentScrollPos);
      $('body').addClass('lockscroll').css({ top: scrollTop });
    } else {
      $searchResults.removeClass('show').css({ height : 0 });
      $('body').removeClass('lockscroll').css({ top: 0 }).scrollLock('disable');
      $('html, body').scrollTop(cachedScrollPos);
    }
  });

  $('.btn-menu').on('click', function (event) {
    event.preventDefault();

    $(this).toggleClass('active');
    $('.header__inner').toggleClass('show');
    $('.wrapper').toggleClass('move');

    if ($('.header__inner').hasClass('show')) {
      cachedScrollPos = currentScrollPos;
      var scrollTop = -Math.abs(currentScrollPos);

      $('.cp-header').toggleClass('sticky').css({ top: currentScrollPos });
      $('.header__inner').toggleClass('sticky');
      $('body').toggleClass('noscroll').css({ top: scrollTop });
    } else {
      $('.cp-header, .header__inner').removeClass('sticky').css({ top: 0 });
      $('body').removeClass('noscroll').css({ top: 0 });
      $('html, body').scrollTop(cachedScrollPos);
    }
  });

  $('nav .parent > a').on('click', function (event) {
    event.preventDefault();

    if ($(this).siblings('.dropdown').length ) {
      $(this)
          .siblings('.dropdown')
          .stop(true, true)
          .slideToggle('fast')
          .parent()
          .toggleClass('dropdown-open')
            .siblings()
            .removeClass('dropdown-open')
            .find('.dropdown')
            .slideUp('fast');
    }
  });

  $('.dropdown-item > a').on('click', function (event) {
    event.preventDefault();

    if ( $(this).siblings('.dropdown').length ) {
      $(this)
          .siblings('.dropdown')
          .stop(true, true)
          .slideToggle('fast')
          .parent()
          .toggleClass('dropdown-open');

      if ( $(this).parent('.dropdown-item').siblings('.dropdown-item').length ) {
        $(this)
          .parent()
          .siblings()
          .removeClass('dropdown-open')
            .find('.dropdown')
            .slideUp('fast');
      } else {
        $(this)
          .parent()
          .parent()
          .siblings()
            .find('.dropdown-item')
            .removeClass('dropdown-open')
              .find('.dropdown')
              .slideUp('fast');
      }
    }
  });

  $('.nav-filter .link-expander').on('click', function (event) {
    event.preventDefault();

    var $this = $(this);

    $this.toggleClass('open');
    $this.closest('.nav-filter').toggleClass('nav-expanded');
    $this.siblings('.nav__inner').slideToggle('fast');

    if ( $('.nav-filter-holder').hasClass('stick') && !$('.nav-filter-holder').hasClass('nav-filter-holder-static') ) {
      var scrollPoint = $('.nav-filter-holder').offset().top - ( $win.outerHeight() - $('.nav-filter-holder').outerHeight() );
      $('html, body').animate({
        scrollTop: scrollPoint
      }, 0);
    }

    setTimeout(function () {
      if ( $('.nav-filter').hasClass('nav-expanded') && !$('.nav-filter-holder').hasClass('nav-filter-holder-static') ) {
        cachedScrollPos = currentScrollPos;
        var scrollTop = -Math.abs(currentScrollPos);

        $('body').toggleClass('noscroll').css({ top: scrollTop });
      } else {
        $('body').removeClass('noscroll').css({ top: 0 });
        $('html, body').scrollTop(cachedScrollPos);
      }
    }, 100);
  });

  // hide if you dont use it
  $doc.on('click touchstart', function (event) {
    if (!$(event.target).parents('li').find('.dropdown').length && !$(event.target).closest('.dropdown').length && !$(event.target).is('nav > ul > li > a') && !$(event.target).is('.dropdown') ) {
      // Wait until event bubbles to document
      setTimeout(function () {
        $('nav > ul > li').removeClass('dropdown-open');
        $('nav .dropdown-item').removeClass('dropdown-open');
        //$('nav .dropdown-item').removeClass('dropdown-open');
        $('nav .dropdown').not('.dropdown-desktop-expand').slideUp('fast');
        $('nav .parent').removeClass('dropdown-open');
      }, 10);
    }
  });

  // Create filter tags
  var $listFilterTags = $('.list-filter-selected');

  $('.filter-group .selected').each(function () {
    var $this = $(this);
    var id = $this.data('filter-id');
    var text = $this.text();

    createTag($listFilterTags, id, text);
  });

  $('.filter-group a').on('click', function (event) {
    event.preventDefault();

    var $this = $(this);
    var id = $this.data('filter-id');
    var text = $this.text();

    $this.toggleClass('selected');

    if ( $this.hasClass('selected') ) {
      createTag($listFilterTags, id, text);
    } else {
      deleteTag($('.list-filter-selected'), id);
    }
  });

  function createTag($parent, id, text) {
    var template = '<li data-filter-id="' + id + '"><span>' + text + '</span><a href="#" class="btn-close"></a></li>';

    $parent.append(template);
  }

  function deleteTag($parent, id) {
    $parent.find('[data-filter-id="' + id + '"]').remove();
  }

  // delete filter and unselect filter in dropdown
  $('.list-filter-selected').on('click', '.btn-close', function (event) {
    event.preventDefault();
    $(this).closest('li').remove();
    var id = $(this).closest('li').data('filter-id');
    $('.filter-group').find('[data-filter-id="' + id + '"]').removeClass('selected');
  });

  $('.reset-filters').on('click', function (event) {
    event.preventDefault();

    $('.filter-group a').removeClass('selected');
    $('.list-filter-selected').html('');
  });

  var $fixedFilterNav = $('.nav-filter-holder');
  var winH = $win.height();

  if ( $fixedFilterNav.length ) {
    $fixedFilterNav.each(function () {
      var $this = $(this);
      var fixedFilterNavHeight = $this.outerHeight();

      $win.on('scroll', function () {
        var scrollTop = $win.scrollTop();
        var filterNavOffset = $this.offset().top;

        if ( scrollTop + winH > filterNavOffset + fixedFilterNavHeight ) {
          $this.addClass('stick');
        } else {
          $this.removeClass('stick');
        }
      });
    });
  }

  var $fixedBtnHolder = $('.btn-cart-holder');

  if ( $fixedBtnHolder.length ) {
    $fixedBtnHolder.each(function () {
      var $this = $(this);
      var fixedBtnHolderHeight = $this.outerHeight();

      $win.on('scroll', function () {
        var scrollTop = $win.scrollTop();
        var fixedBtnHolderOffset = $this.offset().top;

        if ( scrollTop + winH > fixedBtnHolderOffset + fixedBtnHolderHeight ) {
          $this.addClass('stick');
        } else {
          $this.removeClass('stick');
        }
      });
    });
  }

  $('input[type="file"]').on('change', function () {
    var $this = $(this);
    var pathArray = $this.val().split('\\');
    var fileName = pathArray[pathArray.length - 1];
    var $label = $this.siblings('.form__label').find('span');

    if ( $this.val() !== '' ) {
      $label.text(fileName).addClass('active');
    } else {
      $label.text($label.data('default-text')).removeClass('active');
    }
  });

  var $slideVideo = $('.slide__video .video');
  var $videoParent = $slideVideo.closest('.slide__video');

  setVideoSizes($slideVideo, $videoParent);

  //select

  function formatOption(option) {
    if (!option.id) {
      return option.text;
    }

    var $option = $(
      '<span><strong>' + option.text + '</strong><small>' + option.element.dataset.smallText + '</small>'
      );
    return $option;
  }

  $('.select-multiple-tags select').select2({
    templateResult: formatOption,
    templateSelection: formatOption,
    minimumResultsForSearch: Infinity
  });

  $('.select-default select').select2({
    // templateResult: formatOption,
    // templateSelection: formatOption,
    minimumResultsForSearch: Infinity
  });

  $('.tabs__nav select').on('change', function () {
    var target = $(this).find('option:selected').data('target');

    triggerTabFromSelect(target, $('.tabs-contacts'));
  });

  // Charts

  var $barChartElement = $('#graph-bar');
  var barChart = null;
  console.log(barChart, $barChartElement);

  if ($barChartElement.length) {
    var barSrc = $barChartElement.data('source');
    var barCtx = $barChartElement.find('.chart-pane canvas')[0].getContext('2d');

    loadGraphData( barSrc ).then(function (data) {
      barChart = initBarChart(barCtx, data.graph);
    });
  }

  var $barLineChartElement = $('#graph-mixed-bar-line');
  var barLineChart = null;
  console.log(barLineChart);

  if ($barLineChartElement.length) {
    var barLineSrc = $barLineChartElement.data('source');
    var barLineCtx = $barLineChartElement.find('.graph-pane canvas')[0].getContext('2d');

    loadGraphData( barLineSrc ).then(function (data) {
      barLineChart = initMixedBarLineChart(barLineCtx, data.graph);
    });
  }
});

$win.on('load', function () {
  var $grid = $('.grid').isotope({
    itemSelector: '.grid-item',
    layoutMode: 'fitRows'
  });

  $('.list-filters button').on( 'click', function () {
    var filterValue = $( this ).attr('data-filter');

    $grid.isotope({ filter: filterValue });
    $( this ).addClass('is-checked').parent().siblings().find('.is-checked').removeClass('is-checked');
  });

  function setControlsOffsets(index, $this) {
    var contentHeight = $this.closest('.slider-articles-featured').find('.slider__slide').eq(index).find('.article__content').outerHeight();
    var $controls = $this.closest('.slider-articles-featured').find('.slider__actions');

    //console.log(contentHeight);
    //console.log($this.closest('.slider-articles-featured').find('.slider__slide').eq(index));

    $controls.css('top', contentHeight);
  }

  var $sliderArticlesFeatured = $('.slider-articles-featured .slider__slides');

  $sliderArticlesFeatured.each(function () {
    var $this = $(this);

    var sliderOptions = {
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      prevArrow: $this.closest('.slider-articles-featured').find('.slider__prev'),
      nextArrow: $this.closest('.slider-articles-featured').find('.slider__next')
    };

    $this.on('init', function (event, slick) {
      console.log(slick);
      setControlsOffsets(0, $this);
    });

    initSlider($this, sliderOptions);

    $this.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      console.log(currentSlide, nextSlide);
      setControlsOffsets(nextSlide + 1, $this);
    });
  });

  var $sliderWithThreeItem = $('.js-slider-3-items');
  $sliderWithThreeItem.each(function () {
    var $this = $(this);

    var sliderOptions = {
      arrows: false,
      variableWidth: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    initSlider($this, sliderOptions);
  });

  var $sliderVideoArticles = $('.slider-video-article .slider__slides');
  $sliderVideoArticles.each(function () {
    var $this = $(this);

    var sliderOptions = {
      arrows: false,
      variableWidth: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    initSlider($this, sliderOptions);

    $this.on('afterChange', function (event, slick, currentSlide) {
      var $video = $(this).find('video').eq(currentSlide - 1);
      $video[0].pause();
    });
  });

  var $sliderApplications = $('.slider-applications .slider__slides');
  $sliderApplications.each(function () {
    var $this = $(this);

    var sliderOptions = {
      arrows: false,
      variableWidth: true,
      infinite: false,
      slidesToShow: 7,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 1260,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    initSlider($this, sliderOptions);
  });


  var $sliderLocations = $('.slider-locations .slider__slides');
  $sliderLocations.each(function () {
    var $this = $(this);

    var sliderOptions = {
      arrows: false,
      variableWidth: true,
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    initSlider($this, sliderOptions);
  });

  // HTML video
  var $video = $('.video');
  var $btnPlay = $video.siblings('.btn-play');

  console.log($btnPlay);
  $btnPlay.on('click', function (event) {
    event.preventDefault();

    var $videoTarget = $(this).siblings('.video');
    playPause($videoTarget);
  });

  $video.on('click', function () {
    var $videoTarget = $(this);
    playPause($videoTarget);
  });

  $video.on('pause', function () {
    $(this).closest('.video-wrapper').addClass('show-controls');
  });

  function playPause($videoTarget) {
    if ($videoTarget[0].paused) {
      $videoTarget[0].play();
      $videoTarget.closest('.video-wrapper').removeClass('show-controls');
    } else {
      $videoTarget[0].pause();
      $videoTarget.closest('.video-wrapper').addClass('show-controls');
    }
  }

  var $sliderArticles = $('.js-slider-articles');
  $sliderArticles.each(function () {
    var $this = $(this);

    var sliderOptions = {
      arrows: false,
      variableWidth: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            variableWidth: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: true
          }
        }
      ]
    };

    initSlider($this, sliderOptions);
  });

  var $sliderArticlesSecond = $('.js-slider-articles-2');
  $sliderArticlesSecond.each(function () {
    var $this = $(this);

    var sliderOptions = {
      arrows: false,
      variableWidth: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1
            //variableWidth: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
            //variableWidth: true
          }
        }
      ]
    };

    initSlider($this, sliderOptions);
  });

  var $sliderServices = $('.js-slider-services');
  $sliderServices.each(function () {
    var $this = $(this);

    var sliderOptions = {
      arrows: false,
      variableWidth: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            variableWidth: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: true
          }
        }
      ]
    };

    initSlider($this, sliderOptions);
  });

  var $sliderTwitterFeed = $('.js-slider-twitter');
  $sliderTwitterFeed.each(function () {
    var $this = $(this);

    var sliderOptions = {
      arrows: false,
      variableWidth: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    initSlider($this, sliderOptions);
  });

  var $sliderUpdates = $('.js-slider-updates');
  $sliderUpdates.each(function () {
    var $this = $(this);

    var sliderOptions = {
      arrows: false,
      variableWidth: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    initSlider($this, sliderOptions);
  });

  var $sliderTimeline = $('.js-slider-timeline');
  var sliderTimelineOptions = {
    arrows: false,
    variableWidth: false,
    infinite: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  };

  initSlider($sliderTimeline, sliderTimelineOptions);

  var sliderTimelineContentSelected = $sliderTimeline.find('.slider__slide.selected').data('target-index');

  var $sliderTimelineContent = $('.js-slider-timeline-content');
  var sliderTimelineContentOptions = {
    arrows: false,
    variableWidth: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: sliderTimelineContentSelected,
    dots: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  initSlider($sliderTimelineContent, sliderTimelineContentOptions);

  $sliderTimelineContent.on('afterChange', function (event, slick, currentSlide, nextSlide) {
    $sliderTimeline.slick('slickGoTo', currentSlide);
    console.log(event, slick, currentSlide, nextSlide);

    $sliderTimeline
      .find('.slick-slide').eq(currentSlide)
      .find('.slider__slide').addClass('selected')
      .closest('.slick-slide').siblings().find('.slider__slide').removeClass('selected');
  });

  $sliderTimeline.find('.slider__slide').on('click', function () {
    //event.preventDefault();
    var $this = $(this);

    var slideIndex = $this.data('target-index');
    $this.addClass('selected').closest('.slick-slide').siblings().find('.slider__slide').removeClass('selected');

    $sliderTimelineContent.slick('slickGoTo', slideIndex);
  });

  var $sliderGallery = $('.gallery');

  $sliderGallery.each(function () {
    var $this = $(this);
    var $thumbs = $this.find('.gallery-thumbs ul');
    var $bigImage = $this.find('.gallery-main ul');

    var thumbsOptions = {
      arrows: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      vertical: true,
      asNavFor: $bigImage,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            vertical: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            vertical: false
          }
        }
      ]
    };

    initSlider($thumbs, thumbsOptions);

    var bigImageOptions = {
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      asNavFor: $thumbs
    };

    initSlider($bigImage, bigImageOptions);

    $bigImage.on('afterChange', function (slick, currentSlide) {
      console.log(slick, currentSlide);
      var videos = $(slick.currentTarget).find('video');
      for (var i = 0; i < videos.length; i++) {
        videos[i].pause();
      }
    });
  });

  var $sliderTabsNav = $('.tabs__nav-slider > ul');
  $sliderTabsNav.each(function () {
    var $this = $(this);

    var sliderOptions = {
      arrows: true,
      variableWidth: false,
      infinite: false,
      slidesToShow: 7,
      slidesToScroll: 1,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    initSlider($this, sliderOptions);
  });

  // Tabs

  var activeTabClass = 'current';

  $('.tabs__nav a').on('click', function (event) {
    event.preventDefault();

    var $tabLink = $(this);
    var $targetTab = $($tabLink.attr('href'));

    if ( $tabLink.closest('.tabs__nav-slider').length ) {
      $tabLink
        .parent()
        .addClass(activeTabClass)
        .closest('.slick-slide')
          .siblings()
          .find('li')
          .removeClass(activeTabClass);

      $targetTab
        .addClass(activeTabClass)
          .siblings()
          .removeClass(activeTabClass);
    } else {
      $tabLink
        .parent()
        .addClass(activeTabClass)
          .siblings()
          .removeClass(activeTabClass);

      $targetTab
        .addClass(activeTabClass)
          .siblings()
          .removeClass(activeTabClass);
    }

    if ( $tabLink.closest('.header__inner').length ) {
      if ( $('.header__inner').find('.tab.current').length ) {
        $('.header__inner').addClass('tab-open');
      } else {
        $('.header__inner').removeClass('tab-open');
      }
    }
  });

  $('.quote').magnificPopup({
    type: 'inline',
    callbacks: {
      // parseAjax: function (mfpResponse) {
      //   mfpResponse.data = $(mfpResponse.data).find('#sliderContainer');
      // },
      open: function () {
        var startIndex = this._lastFocusedEl.dataset.index;
        var sliderContainer = this.content[0];
        var $slider = $(sliderContainer).find('.slider__slides');

        if ( typeof startIndex === 'undefined' ) {
          startIndex = this.index;
        }

        $slider.slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          initialSlide: parseInt(startIndex, 10),
          adaptiveHeight: true
        });
      },
      close: function () {
        var sliderContainer = this.content[0];
        //console.log(sliderContainer);
        var $slider = $(sliderContainer).find('.slider__slides');
        if ( $slider.hasClass('slick-initialized') ) {
          $slider.slick('unslick');
        }
      }
    }
  });
  console.log(layoutType);

  $('.chatbot-trigger').on('click', function (event) {
    event.preventDefault();

    $(this).toggleClass('active');
    $('.chat-bot').toggleClass('show');

    // if Mobile Lock body scroll, allow chat container scroll
    if ( layoutType === 'mobile' ) {
      $('.chat-container').scrollLock('enable');
      $('body').addClass('lockscroll');
    } else {
      $('body').removeClass('lockscroll').scrollLock('disable');
    }
  });

  $('.chat-bot .btn-close').on('click', function (event) {
    event.preventDefault();

    $(this).closest('.chat-bot').removeClass('show');
    $('.chatbot-trigger').removeClass('active');
    $('body').removeClass('lockscroll').scrollLock('disable');
  });

  $('.tab .link-back').on('click', function (event) {
    event.preventDefault();

    var $this = $(this);
    var $parentTab = $this.parent();
    $parentTab.removeClass('current');

    $this.closest('.tabs').find('.tabs__nav li.current').removeClass('current');
    $('.header__inner').removeClass('tab-open');
  });

  // This class will be added to the expanded item
  var activeItemClass = 'accordion__expanded';
  var accordionItemSelector = '.accordion__section';
  var toggleSelector = '.accordion__head';

  $(toggleSelector).on('click', function () {
    $(this)
      .closest(accordionItemSelector) // go up to the accordion item element
      .toggleClass(activeItemClass)
      .find('.accordion__body').stop(true, true).slideToggle(300)
      .closest(accordionItemSelector)
      .siblings()
      .removeClass(activeItemClass)
      .find('.accordion__body').stop(true, true).slideUp(300);
  });
});

